export default class Utils {
  static createPromise(source, args) {
    
    // Return promises as they are
    if (source instanceof Promise) {
      return source;
    }
    
    // Source is a function
    if (typeof source === 'function') {
      return new Promise((resolve, reject) => {
        try {
          let funcArgs = args || [];
          resolve(source(...funcArgs));
        }
        catch (e) {
          reject(e);
        }
      });
    }
    
    // Source is a value
    return Promise.resolve(source);
    
  }
}


// WEBPACK FOOTER //
// ./modules/cliser/src/utils.js